<template>
    <div>
        <el-dialog :visible.sync="showBox" @close="closeModal" width="700px">
            <p slot="title" style="text-align: center; color: #1A86FE">
                <span>{{$store.state.agentInfo.name}}隐私政策</span>
            </p>
            <div class="server-font">
                <personal-comp></personal-comp>
            </div>
            <p slot="footer"></p>
        </el-dialog>
	</div>
</template>

<script>
import personalComp from '@/components/about/personal'
export default {
    data(){
        return{
        }
    },
    components: {
        personalComp
    },
    props:['showserver'],
    computed:{
        showBox:{
            get: function() {
                return this.showserver
            },
            set: function() {
            }
        }
    },
    methods:{
        closeModal(){
            this.$emit('update-show',false);
        }
    }
}
</script>

<style scoped lang="scss">
.server-font{
  height:600px;
  overflow-y: scroll;
  -ms-overflow-y: scroll;
  li{
    color: rgb(88,88,88);
    margin-bottom: 25px;
    span,p{
      font-size: 14px;
      font-weight: bold;
      color: rgb(37,37,37);
    }
  }
  li:first-child{
    color: rgb(37,37,37);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/personal.vue